import { getResourceUrl, useWtxLocalization } from '@wavetronix/common-components'
import { useState } from 'react'
import { CircularProgress } from '@mui/material'

const classes = {
  buttonBase: {
    display: 'block',
    width: '100%',
    height: '100%',
    color: 'transparent'
  },
  imageBase: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 'auto'
  },
  titleText: {
    fontFamily: 'Proxima Nova',
    fontWeight: 'bold',
    fontSize: 18,
    display: 'inline',
    verticalAlign: 'middle',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    color: 'white'
  },
  titleIcon: {
    width: '12em',
    height: '12em'
  },
  appCard: {
    borderRadius: '20px',
    boxShadow: '3px 0px 53px -20px rgba(0,0,0,0.6)',
    display: 'block',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  }
}

export default function AppCard({ app, env, onClick, cursor }) {
  const [redirect, SetRedirect] = useState(true)
  let localizedStrings = useWtxLocalization()

  const getAppName = app => {
    let appName = app
    if (Object.keys(localizedStrings).includes(app)) {
      appName = localizedStrings[app]
    }
    return appName
  }

  return (
    <div
      style={{ ...classes.appCard, cursor: cursor }}
      onMouseDown={_ => {
        SetRedirect(true)
      }}
      onMouseUp={_ => {
        if (redirect === true) {
          onClick()
        }
      }}
      onMouseMove={_ => {
        SetRedirect(false)
      }}
      onTouchStart={_ => {
        SetRedirect(true)
      }}
      onTouchEnd={_ => {
        if (redirect === true) {
          onClick()
        }
      }}
      onTouchMove={_ => {
        SetRedirect(false)
      }}>
      <div style={{ height: '80%', ...classes.imageBase }}>
        {app && app.icon ? (
          <img alt={app.appName} style={classes.titleIcon} src={`${getResourceUrl(env)}/images/apps/${app.icon}`} />
        ) : (
          <CircularProgress />
        )}
      </div>
      <div
        style={{
          backgroundColor: app.color,
          height: '20%',
          borderRadius: '0px 0px 20px 20px',
          ...classes.imageBase
        }}>
        <div style={classes.titleText}>{getAppName(app.appName)}</div>
      </div>
    </div>
  )
}
